var render = function render(){var _vm=this,_c=_vm._self._c;return (
    !_vm.$store.state.fetchingFile &&
      _vm.link.toc !== false &&
      _vm.link.link === _vm.$route.path &&
      _vm.$store.state.page.headings &&
      _vm.$store.state.page.headings.length > 0
  )?_c('div',{staticClass:"PageToc"},_vm._l((_vm.$store.state.page.headings),function(heading){return _c('router-link',{key:heading.slug,staticClass:"PageTocHeading",attrs:{"to":{hash: heading.slug},"data-level":heading.level},domProps:{"innerHTML":_vm._s(heading.text)}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }